import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=a72db4f4&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=a72db4f4&prod&lang=scss&scoped=true"
import style1 from "./ProfileInfo.vue?vue&type=style&index=1&id=a72db4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72db4f4",
  null
  
)

export default component.exports